/* eslint-disable jsx-a11y/label-has-associated-control */
import { useTranslation } from 'next-i18next';
import cn from 'classnames';
import { MecProduct } from '@adapters/bigcommerce/types/product';
import { useComparison } from '@context/CompareContext';
import React from 'react';
import styles from './ComparisonCheckbox.module.scss';

interface ComparisonCheckboxProps {
  product: MecProduct | { code: MecProduct['code'] };
  isPdp?: boolean;
}

const ComparisonCheckbox = ({ product, isPdp }: ComparisonCheckboxProps) => {
  const { t } = useTranslation('comparison');

  const { addItem, removeItem, allItems, addPendingItem } = useComparison();

  if (!product.code) return null;

  const toggleComparison = () => {
    if (!product.code) return;

    if (allItems.includes(product.code)) {
      removeItem(product.code);
    } else {
      // on the product page we have alot more data available than in the search results.
      if (
        'code' in product &&
        'images' in product &&
        'slug' in product &&
        'name' in product &&
        'price' in product &&
        'techSpecs' in product &&
        'reviewSummary' in product
      ) {
        addItem(product); // TODO - it should be noted that there is currently a bug where we are not using the variant of the product when comparing just the default. Could create new GraphQL query to handle
      } else {
        // by adding it to the pending items we can fetch the product data later.
        addPendingItem(product.code);
      }
    }
  };

  return (
    <div className={cn(styles.container, { [styles.pdp]: isPdp })}>
      <label>
        <input
          type="checkbox"
          onChange={toggleComparison}
          checked={allItems.includes(product.code)}
        />
        <span>{t('compare')}</span>
      </label>
    </div>
  );
};

export default ComparisonCheckbox;
